import React from "react";
import pdfContext from "./support/PdfContext";
import {useAxiosSetup} from "../Api";
import PopupWarning from "../dialogs/PopupWarning";
import {useModal} from "../dialogs/ModalContext";


function PdfGenerator(props) {
    const {pdfGenerationDone} = React.useContext(pdfContext)
    const api = useAxiosSetup();
    const {showModal} = useModal();

    function getCurrentDateTime() {
        const now = new Date();

        const year = now.getFullYear();
        const month = (now.getMonth() + 1).toString().padStart(2, '0');
        const day = now.getDate().toString().padStart(2, '0');
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const seconds = now.getSeconds().toString().padStart(2, '0');

        return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
    }

    function getLink() {
        if (props.reportType === 'serviceCase') {
            return `/service_case/service_cases/${props.reportId}/generate_report`
        } else if (props.reportType === 'serviceCaseQr') {
            return `/service_case/service_cases/${props.reportId}/generate_qr`
        } else if (props.reportType === 'serviceCaseQuotation') {
            return `/service_case/service_cases/${props.reportId}/generate_quotation`

        } else if (props.reportType === 'loan') {
            return `/loan/loans/${props.reportId}/generate_report`

        } else if (props.reportType === 'installation') {
            return `/installation/installations/${props.reportId}/generate_report`

        } else if (props.reportType === 'btk') {
            return `/btk/btks/${props.reportId}/generate_report`
        } else if (props.reportType === 'btkQuotation') {
            return `/btk/btks/${props.reportId}/generate_quotation`

        } else if (props.reportType === 'instrumentQr') {
            return `/instrument/instruments/${props.reportId}/generate_qr`

        } else {
            showModal(PopupWarning, `Nerozpoznaný druh reportu: ${props.reportType}`, () => {
            })
            return ""
        }
    }

    function decodeMimeFilename(mimeString) {
        if (mimeString.startsWith('=?utf-8?b?') && mimeString.endsWith('?=')) {
            // Extract the base64 encoded part
            const base64Encoded = mimeString.slice(10, -2); // Remove '=?utf-8?b?' and '?='
            // Decode the base64 string and convert to a UTF-8 string
            const decodedString = atob(base64Encoded);
            return new TextDecoder('utf-8').decode(new Uint8Array(decodedString.split('').map(char => char.charCodeAt(0))));
        }
        return mimeString; // Return as-is if not encoded
    }

    React.useEffect(() => {
        let link = getLink()
        if (link === "") {
            pdfGenerationDone()
            return
        }
        if (props.preview) {
            link = link + '_preview'
        }
        link = link + '/'
        if (props.version) {
            link = link + `?version=${props.version}`
        }
        const data = props.data
        if (link === "") {
            pdfGenerationDone()
        // next check if report type contains Qr
        } else if (props.reportType.includes('Qr')) {
            api.get(link, {params: data, responseType: 'blob'}).then(response => {
                const blob = new Blob([response.data], {type: props.preview ? 'text/html' : 'application/pdf'});
                const url = window.URL.createObjectURL(blob);
                const now = getCurrentDateTime();
                const newWindow = window.open(url, '_blank');
                // Delay the revocation of the URL to allow for the file to be downloaded
                setTimeout(() => {
                    window.URL.revokeObjectURL(url);
                }, 3600000); // 6
            })
            pdfGenerationDone()
        } else {
            api.get(link, {params: data, responseType: 'blob'}).then(response => {
                const blob = new Blob([response.data], { type: props.preview ? 'text/html' : 'application/pdf' });
                if (props.preview) {
                    const url = window.URL.createObjectURL(blob);
                    const now = getCurrentDateTime();
                    const newWindow = window.open(url, '_blank');
                    // Delay the revocation of the URL to allow for the file to be downloaded
                    setTimeout(() => {
                        window.URL.revokeObjectURL(url);
                    }, 3600000); // 60 min delay
                } else {
                    let fileName = decodeMimeFilename(response.headers['x-filename']); // Decode the file name

// Create a Blob from the response directly
                    const blob = new Blob([response.data], { type: 'application/pdf' }); // Ensure MIME type is 'application/pdf'

// Generate a Blob URL for the PDF
                    const blobUrl = URL.createObjectURL(blob);

// Open a new blank tab
                    const newTab = window.open('', '_blank');

                    if (newTab) {
                        // Write custom HTML into the new tab
                        newTab.document.open();
                        newTab.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <title>${fileName.slice(0, -4)}</title>
            <style>
                /* Ensure the body and embed take up the full height of the viewport */
                html, body {
                    margin: 0;
                    padding: 0;
                    height: 100%;
                }
                embed {
                    width: 100%;
                    height: 94%; /* Adjust as needed */
                }
            </style>
        </head>
        <body>
            <!-- Embed the Blob URL -->
            <embed src="${blobUrl}" type="application/pdf" />
            <br>
            <!-- Provide a fallback download link -->
            <a style="font-size: 36px;" href="${blobUrl}" download="${fileName}">Stiahnuť</a>
        </body>
        </html>
    `);
                        newTab.document.close();
                    }
                }
                pdfGenerationDone()
            })
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    return (
        <></>
    )
}

export default PdfGenerator
